angular.module('gym.availability', []);
